var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmallHandWeights(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 68,
    viewBox: "0 0 94 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2224_1077)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 33.5996L4.1 40.4996L15.4 46.7996L11.3 39.8996L0 33.5996Z",
    fill: "#8872B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3998 28.2996L11.2998 39.8996L15.3998 46.7996L15.6998 46.5996L21.3998 43.3996L15.4998 39.9996C15.1998 39.4996 14.9998 38.7996 14.9998 37.9996C14.9998 37.0996 15.1998 36.1996 15.5998 35.2996C15.7998 34.8996 15.9998 34.3996 16.2998 33.8996C17.1998 32.4996 18.1998 31.3996 19.2998 30.6996C20.1998 30.1996 20.9998 29.9996 21.6998 30.0996L26.7998 32.9996L27.6998 30.4996L23.5998 23.5996L15.3998 28.2996Z",
    fill: "#6D5996"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 29.3L0 33.6L11.3 39.9L15.4 28.3L4.1 22L1.5 29.3Z",
    fill: "#9B85CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3001 17.2998L4.1001 21.9998L15.4001 28.2998L23.6001 23.5998L17.6001 20.2998L12.3001 17.2998Z",
    fill: "#AE9AD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8002 30.7994C22.5002 30.5994 22.2002 30.2994 21.9002 30.1994C19.5002 28.9994 16.4002 30.4994 15.0002 33.4994C13.6002 36.4994 14.3002 39.7994 16.7002 40.9994L36.6002 52.3994L43.1002 42.4994L22.8002 30.7994Z",
    fill: "url(#paint0_linear_2224_1077)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8999 54.2998L39.3999 60.0998L39.9999 61.1998L51.2999 67.4998L47.0999 60.5998L35.8999 54.2998Z",
    fill: "#8872B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3001 48.9998L47.1001 60.5998L51.3001 67.4998L51.7001 67.1998L59.4001 62.7998L61.3001 57.3998L63.5001 51.1998L59.4001 44.2998L51.3001 48.9998Z",
    fill: "#6D5996"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8 41.7L40 42.7L51.3 49L59.4 44.3L48.1 38L41.8 41.7Z",
    fill: "#AE9AD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5999 52.1002L35.8999 54.3002L47.1999 60.6002L51.2999 49.0002L39.9999 42.7002L36.5999 52.1002Z",
    fill: "#9B85CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5 16.5L34.6 23.4L45.9 29.7L41.8 22.8L30.5 16.5Z",
    fill: "#8872B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8998 11.2L41.7998 22.8L45.8998 29.7L46.1998 29.5L51.8998 26.3L45.9998 22.9C45.6998 22.4 45.4998 21.7 45.4998 20.9C45.4998 20 45.6998 19.1 46.0998 18.2C46.2998 17.8 46.4998 17.3 46.7998 16.8C47.6998 15.4 48.6998 14.3 49.7998 13.6C50.6998 13.1 51.4998 12.9 52.1998 13L57.2998 15.9L58.1998 13.4L53.9998 6.5L45.8998 11.2Z",
    fill: "#6D5996"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 12.2004L30.5 16.5004L41.8 22.8004L45.9 11.2004L34.6 4.90039L32 12.2004Z",
    fill: "#9B85CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8001 0.200195L34.6001 4.9002L45.9001 11.2002L54.1001 6.5002L48.0001 3.2002L42.8001 0.200195Z",
    fill: "#AE9AD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3002 13.6998C53.0002 13.4998 52.7002 13.1998 52.4002 13.0998C50.0002 11.8998 46.9002 13.3998 45.5002 16.3998C44.1002 19.3998 44.8002 22.6998 47.2002 23.8998L67.1002 35.2998L73.6002 25.3998L53.3002 13.6998Z",
    fill: "url(#paint1_linear_2224_1077)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3999 37.2002L69.8999 43.0002L70.4999 44.1002L81.7999 50.4002L77.5999 43.5002L66.3999 37.2002Z",
    fill: "#8872B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8001 31.9002L77.6001 43.5002L81.8001 50.4002L82.2001 50.1002L89.9001 45.7002L91.8001 40.3002L94.0001 34.1002L89.9001 27.2002L81.8001 31.9002Z",
    fill: "#6D5996"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3 24.6004L70.5 25.6004L81.8 31.9004L89.9 27.2004L78.6 20.9004L72.3 24.6004Z",
    fill: "#AE9AD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0999 35.0006L66.3999 37.2006L77.5999 43.5006L81.7999 31.9006L70.4999 25.6006L67.0999 35.0006Z",
    fill: "#9B85CA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2224_1077",
    x1: 31.1178,
    y1: 35.6743,
    x2: 24.0197,
    y2: 45.1922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE9AD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3822,
    stopColor: "#8E7BC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D4D9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2224_1077",
    x1: 61.6074,
    y1: 18.5747,
    x2: 54.5093,
    y2: 28.0926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE9AD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3822,
    stopColor: "#8E7BC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D4D9B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2224_1077"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 68,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallHandWeights);
export default __webpack_public_path__ + "static/media/SmallHandWeights.4a3379eed846a4daac4e755039d14435.svg";
export { ForwardRef as ReactComponent };